import { render } from "./readUser.vue?vue&type=template&id=f5e06150"
import script from "./readUser.vue?vue&type=script&lang=js"
export * from "./readUser.vue?vue&type=script&lang=js"

import "./readUser.vue?vue&type=style&index=0&id=f5e06150&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__